var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,19.5A19.5,19.5,0,1,1,19.5,0,19.5,19.5,0,0,1,39,19.5Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,15.53a4,4,0,1,0,4,4,4,4,0,0,0-4-4Zm9.09,1.84-1.42-.24a8.35,8.35,0,0,0-.57-1.38l.84-1.17A1.25,1.25,0,0,0,27.3,13L26,11.71a1.25,1.25,0,0,0-1.61-.14l-1.17.84a8.22,8.22,0,0,0-1.44-.59l-.23-1.4a1.25,1.25,0,0,0-1.24-1.05H18.57a1.25,1.25,0,0,0-1.23,1.05l-.25,1.44a7.21,7.21,0,0,0-1.38.58l-1.16-.84a1.26,1.26,0,0,0-1.61.13L11.67,13a1.26,1.26,0,0,0-.13,1.62l.84,1.19a8.31,8.31,0,0,0-.56,1.38l-1.4.24a1.25,1.25,0,0,0-1.05,1.23v1.78a1.25,1.25,0,0,0,1.05,1.24l1.44.24a7,7,0,0,0,.58,1.38l-.84,1.16a1.25,1.25,0,0,0,.14,1.61L13,27.32a1.23,1.23,0,0,0,.88.37,1.26,1.26,0,0,0,.73-.23l1.19-.85a7.76,7.76,0,0,0,1.33.55l.24,1.42a1.25,1.25,0,0,0,1.23,1.05h1.79a1.26,1.26,0,0,0,1.24-1.05l.24-1.42a8.35,8.35,0,0,0,1.38-.57l1.17.84A1.25,1.25,0,0,0,26,27.29L27.29,26a1.26,1.26,0,0,0,.14-1.61l-.84-1.18a7.57,7.57,0,0,0,.57-1.38l1.42-.23a1.26,1.26,0,0,0,1.05-1.24V18.61A1.25,1.25,0,0,0,28.59,17.37Z",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.f1fedc042d6d9f81eb838c7510ef0281.svg";
export { ForwardRef as ReactComponent };